export const extractErrorMessage = (
  error: unknown,
  defaultMessage: string,
): string => {
  if (error && typeof error === 'object') {
    const err = error as Record<string, unknown>;
    const responseData = err?.response as Record<string, unknown> | undefined;
    const dataMessage = responseData?.data as
      | Record<string, unknown>
      | undefined;
    const message = dataMessage?.message;
    // Handle array of messages (NestJS validation errors) - show only first
    if (Array.isArray(message) && message.length > 0) {
      return message[0];
    }
    return (message as string) || (err?.message as string) || defaultMessage;
  }
  return defaultMessage;
};
